The event ID criteria used to determine which events will be replayed.
